var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2742_30342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6054 8.95126C16.6054 12.979 13.3402 16.2442 9.31245 16.2442L9.31245 17.7442C14.1686 17.7442 18.1054 13.8075 18.1054 8.95126L16.6054 8.95126ZM9.31245 16.2442C5.28468 16.2442 2.01953 12.979 2.01953 8.95126L0.519531 8.95126C0.519531 13.8075 4.45625 17.7442 9.31245 17.7442L9.31245 16.2442ZM2.01953 8.95126C2.01953 4.92349 5.28468 1.65834 9.31245 1.65834L9.31245 0.15834C4.45625 0.15834 0.519531 4.09506 0.519531 8.95126L2.01953 8.95126ZM9.31245 1.65834C13.3402 1.65834 16.6054 4.92349 16.6054 8.95126L18.1054 8.95126C18.1054 4.09506 14.1686 0.15834 9.31245 0.15834L9.31245 1.65834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 12.9407L15.7852 12.9407",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 2.75,
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.9407H11.125V21.3417C11.125 21.8939 10.6773 22.3417 10.125 22.3417H8.5C7.94772 22.3417 7.5 21.8939 7.5 21.3417V12.9407Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2742_30342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.dda78fada426c1e112a0e4a5da253455.svg";
export { ForwardRef as ReactComponent };